<template>
  <div id="notificationPage">
    <h1>Notifs</h1>
    <div>
      <h2>Gérer mon inscription</h2>
      <input v-model="pseudo" placeholder="Pseudo"><button v-if="!isSubscribed" @click="subscribe">M'enregistrer</button>
      <button v-if="isSubscribed" @click="unsubscribe">Me désinscrire</button>
    </div><br>
    <div>
      <h2>Notifier tous les inscrits</h2>
      <input v-model="messageToSend" placeholder="Message à transmettre">
      <button @click="sendMessage">Envoyer !</button>
    </div><br>
    <div>
      <h2>Liste des inscrits</h2>
      <div v-if="subscriptions">
        <p v-for="(subscription, index) in subscriptions" :key="subscription">
          {{subscription && subscription.pseudo ? subscription.pseudo : index}} <button @click="deleteSubscription(index)">Supprimer</button>
        </p>
      </div>
      <button @click="listActiveSubscriptions">Actualiser</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NotificationPage',
  components: {
  },

  data: () => ({
    isSubscribed: false,
    publicKey: 'BNoTdTxcn1AdS_Gs3Ynejntavvm9q3QZj9YdvOR-lfxiBKjFjflSoD8Wl0tWOHSPuLspB_gOfpwehvW4gURqArc', // Generated with npm run generateVapidKeys, same as the back one
    swRegistration: null,
    endPoint: null,
    messageToSend: '',
    subscriptions: {},
    pseudo: ''
  }),

  props: {
  },

  methods: {
    listActiveSubscriptions() {
      axios.get('/api/list').then(res => {
        this.subscriptions = res.data;
      });
    },
    checkSubscriptionStatus() {
      navigator.serviceWorker.ready.then((reg) => {
          reg.pushManager.getSubscription()
              .then((subscription) => {
                  if (!subscription) {
                      this.isSubscribed = false;
                  } else {
                      this.isSubscribed = true;
                  }
              })
              .catch((err) => {
                  console.log('Error during getSubscription()', err);
              });
      });
    },
    subscribe() {
      navigator.serviceWorker.ready.then((reg) => {
        var subscribeParams = {
          userVisibleOnly: true,
          applicationServerKey: this.urlB64ToUint8Array(this.publicKey) // Setting the public key of the VAPID key pair.
        };
        reg.pushManager.subscribe(subscribeParams)
          .then((subscription) => {
              // Update status to subscribe current user on server, and to let
              // other users know this user has subscribed
              this.endpoint = subscription.endpoint;
              var key = subscription.getKey('p256dh');
              var auth = subscription.getKey('auth');
              this.sendSubscriptionToServer(this.endpoint, key, auth);
              console.log('User is subscribed.');
              this.isSubscribed = true;
          })
          .catch(function (e) {
              // A problem occurred with the subscription.
              console.log('Unable to subscribe to push.', e);
          });
      });
    },
    sendSubscriptionToServer(endpoint, key, auth) {
      var encodedKey = btoa(String.fromCharCode.apply(null, new Uint8Array(key)));
      var encodedAuth = btoa(String.fromCharCode.apply(null, new Uint8Array(auth)));
      axios.post('/api/subscribe', {publicKey: encodedKey, auth: encodedAuth, notificationEndPoint: endpoint, pseudo: this.pseudo}).then(() => this.listActiveSubscriptions());
      this.pseudo = '';
    },
    deleteSubscription(uniqueEndpoint) {
      axios.post('/api/unsubscribe', {notificationEndPoint: uniqueEndpoint}).then(() => this.listActiveSubscriptions());
    },
    unsubscribe() {
      this.swRegistration.pushManager.getSubscription()
        .then((subscription) => {
            if (subscription) {
                this.endpoint = subscription.endpoint;
                return subscription.unsubscribe();
            }
        })
        .catch((error) => {
            console.log('Error unsubscribing', error);
        })
        .then(() => {
            this.removeSubscriptionFromServer(this.endpoint);
            console.log('User is unsubscribed.');
            this.isSubscribed = false;
      });
    },
    removeSubscriptionFromServer(endpoint) {
      axios.post('/api/unsubscribe', {notificationEndPoint: endpoint}).then(() => this.listActiveSubscriptions());
    },
    requestPushPermission() {
      Notification.requestPermission().then((status) => {
        if (status === 'denied') {
            console.log('[Notification.requestPermission] The user has blocked notifications.');
        } else if (status === 'granted') {
            console.log('[Notification.requestPermission] Initializing service worker.');
            this.listenPush();
        }
      });
    },
    listenPush() {
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        navigator.serviceWorker.register(process.env.BASE_URL + 'sw.js')
        .then((swReg) => {
          console.log('Service Worker is registered', swReg);
          this.swRegistration = swReg;
        })
        .catch((error) => {
          console.error('Service Worker Error', error);
        });
      } else {
        console.warn('Push messaging is not supported');
        alert('Push Not Supported')
      }
    },
    urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    },
    sendMessage() {
      axios.post('/api/notifyAll', {
          "title": "Info super cool",
          "clickTarget": "http://www.google.com",
          "message": this.messageToSend
      });
    }
  },

  mounted() {
    this.checkSubscriptionStatus();
    this.requestPushPermission();
    this.listActiveSubscriptions();
  },

  computed: {
  }
}
</script>

<style>
</style>